// extracted by mini-css-extract-plugin
export default {"card":"UnlockingPotentialCard2_card__3kk2L","div1":"UnlockingPotentialCard2_div1__VAaXx","div2":"UnlockingPotentialCard2_div2__gXtdz","div3":"UnlockingPotentialCard2_div3__VtLZ5"};